import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { Feature, Point, Polygon } from 'geojson';

interface CircleGeoJsonProperties {
  [key: string]: any;
  id: string;
  user_isCircle: boolean;
}

export function createSupplementaryPointsForCircle(
  geojson: Feature<Polygon, CircleGeoJsonProperties>
): Feature<Point>[] | null {
  const { geometry, properties } = geojson;

  if (!properties.user_isCircle) {
    return null;
  }

  const supplementaryPoints: Feature<Point>[] = [];

  const vertices = geometry.coordinates[0].slice(0, -1);

  for (let index = 0; index < vertices.length; index += Math.round(vertices.length / 4)) {
    supplementaryPoints.push(MapboxDraw.lib.createVertex(properties.id, vertices[index], `0.${index}`, false));
  }

  return supplementaryPoints;
}

interface MapContext {
  _ctx: {
    store: {
      getInitialConfigValue: (key: string) => boolean;
    };
  };
  map: {
    doubleClickZoom: any;
    dragPan: {
      disable: () => void;
      enable: () => void;
    };
  };
}

export const dragPan = {
  disable(ctx: MapContext) {
    setTimeout(() => {
      if (!ctx.map || !ctx.map.doubleClickZoom) {
        return;
      }
      ctx.map.dragPan.disable();
    }, 0);
  },

  enable(ctx: MapContext) {
    setTimeout(() => {
      if (!ctx.map || !ctx.map.dragPan || !ctx._ctx || !ctx._ctx.store || !ctx._ctx.store.getInitialConfigValue) {
        return;
      }
      if (!ctx._ctx.store.getInitialConfigValue('dragPan')) {
        return;
      }
      ctx.map.dragPan.enable();
    }, 0);
  }
};
